import { apiFetch } from "./httpClient";

async function getDashboardData(path, filters = {}) {
  const queryParams = new URLSearchParams(filters).toString();
  const result = await apiFetch(
    `dashboard/${path}${queryParams ? `?${queryParams}` : ""}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  return result.data;
}

export class Dashboard {
  /**
   * GET /api/v1/dashboard/admin/overview
   * Get overview dashboard with key metrics
   */
  async getOverview(filters = {}) {
    return getDashboardData("admin/overview", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/enrollment
   * Get comprehensive enrollment analytics
   */
  async getEnrollmentAnalytics(filters = {}) {
    return getDashboardData("admin/enrollment", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/attendance
   * Get comprehensive attendance analytics
   */
  async getAttendanceAnalytics(filters = {}) {
    return getDashboardData("admin/attendance", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/financial
   * Get comprehensive financial analytics
   */
  async getFinancialAnalytics(filters = {}) {
    return getDashboardData("admin/financial", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/academic
   * Get comprehensive academic performance analytics
   */
  async getAcademicAnalytics(filters = {}) {
    return getDashboardData("admin/academic", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/teaching
   * Get teaching and course analytics
   */
  async getTeachingAnalytics(filters = {}) {
    return getDashboardData("admin/teaching", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/operations
   * Get operational metrics
   */
  async getOperationalMetrics(filters = {}) {
    return getDashboardData("admin/operations", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/students-at-risk
   * Get detailed list of students at risk
   */
  async getStudentsAtRisk(filters = {}) {
    return getDashboardData("admin/students-at-risk", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/payment-summary
   * Get detailed payment summary by student
   */
  async getPaymentSummary(filters = {}) {
    return getDashboardData("admin/payment-summary", filters);
  }

  /**
   * GET /api/v1/dashboard/admin/attendance-trends
   * Get attendance trends over time
   */
  async getAttendanceTrends(filters = {}) {
    return getDashboardData("admin/attendance-trends", filters);
  }

  // STUDENT DASHBOARD ENDPOINTS

  /**
   * GET /api/v1/dashboard/student/overview
   * Get student overview
   */
  async getStudentOverview() {
    return getDashboardData("student/overview");
  }

  /**
   * GET /api/v1/dashboard/student/academic
   * Get student academic performance
   */
  async getStudentAcademic() {
    return getDashboardData("student/academic");
  }

  /**
   * GET /api/v1/dashboard/student/financial
   * Get student financial status
   */
  async getStudentFinancial() {
    return getDashboardData("student/financial");
  }

  /**
   * GET /api/v1/dashboard/student/attendance
   * Get student attendance details
   */
  async getStudentAttendance() {
    return getDashboardData("student/attendance");
  }

  /**
   * GET /api/v1/dashboard/student/learning
   * Get student learning progress
   */
  async getStudentLearning() {
    return getDashboardData("student/learning");
  }

  /**
   * GET /api/v1/dashboard/student/documents
   * Get student documents
   */
  async getStudentDocuments() {
    return getDashboardData("student/documents");
  }

  /**
   * GET /api/v1/dashboard/student/schedule
   * Get student class schedule
   */
  async getStudentSchedule() {
    return getDashboardData("student/schedule");
  }

  /**
   * GET /api/v1/dashboard/student/notifications
   * Get student notifications
   */
  async getStudentNotifications() {
    return getDashboardData("student/notifications");
  }

  /**
   * GET /api/v1/dashboard/student/attendance-calendar
   * Get student attendance calendar
   */
  async getStudentAttendanceCalendar() {
    return getDashboardData("student/attendance-calendar");
  }
}
